import React, { useState } from 'react';
import '../styles/Portfolio.css';

const PortfolioItem = ({ image, index, itemInfo }) => {
  const [isFlipped, setIsFlipped] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Get the item information corresponding to the image index
  const { item_name, item_description } = itemInfo[index] || {};


  const handleFlip = () => {
    setIsFlipped(!isFlipped);
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className={`portfolio-container card-container ${isFlipped ? 'flipped' : ''}`}>
      {/* Front Side */}
      <div className='portfolio-card card front'>
        <img src={image.url} alt={item_name} className="item-image" onClick={openModal}/>
        <h3 className="item-name">{item_name}</h3>
        <div onClick={handleFlip} className="item-description-container">
          <p className="item-description">Click to see the description</p>
        </div>
      </div>

      {/* Back Side */}
      <div className='portfolio-card card back'>
        <p className="item-description-back">{item_description}</p>
        <div onClick={handleFlip} className="item-description-container">
          <p className="item-description">Click to see the info</p>
        </div>
      </div>

      {/* Modal for Enlarged Image */}
      {isModalOpen && (
        <div className="modal-background" onClick={closeModal}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <span className="close-modal" onClick={closeModal}>&times;</span>
            <img src={image.url} alt={item_name} className="full-image" />
          </div>
        </div>
      )}
    </div>
  );
};

export default PortfolioItem;